module.exports = __webpack_public_path__ + "static/media/CN.68ea7a44.png";